/**
 * Created by fers on 09/05/2017.
 */
import {DEFAULT_LOCALE, getLocalesMyAppSupports} from '../../common/locales';

export function getLocalizedText(msg, locale = DEFAULT_LOCALE) {
    if (!msg) {
        return null;
    }

    if (typeof msg === "string") {
        return msg;
    }

    let localizedText = msg[locale];
    if (!localizedText) {
        localizedText = msg[DEFAULT_LOCALE];
    }

    if (!localizedText) {
        for (let lang of getLocalesMyAppSupports()) {
            if (msg && msg[lang]) {
                localizedText = msg[lang];
                break;
            }
        }
    }

    return localizedText;
}
